<template>
  <header id="header">
    <b-container>
      <b-row>
        <b-col>
          <h1>Tachi.ai Ventures</h1>
          <h3>
            We invest in the road less traveled.
          </h3>
        </b-col>
      </b-row>

      <b-row align-v="end">
        <b-col class="d-flex justify-content-center">
          <div
            style="height:100px;width:100px"
            v-scroll-to="'#values'"
            class="d-flex align-items-center justify-content-center"
          >
            <i
              class="fas fa-chevron-down animated infinite bounce delay-2s slow cursor"
            ></i>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
/*
COLORS:

Light green: #F1948A  
Medium green: #E74C3C
Dark red: #B03A2E

Light black: #808B96   
Medium black: #273746  
Dark black: #212F3D  
*/

#header {
  background-image: url(../assets/daigoji.jpg);
  background-position: top center;
  background-size: cover;
  color: white;
  align-items: center;
  text-align: center;
  height: 100vh;
  display: flex;
}

#header h1 {
  color: white;
  font-size: 600%;
  font-weight: 700;
  letter-spacing: 0.3rem;
  text-shadow: 0.1rem 0.1rem 0.8rem black;
  padding-bottom: 1rem;
  padding-top: 160px;
  animation-name: moveInLeft;
  animation-duration: 1s;
  animation-timing-function: ease-out;
}

@media (max-width: 768px) {
  #header h1 {
    font-size: 400%;
  }
  #header h3 {
    font-size: 1.5rem;
  }
}

#header h3 {
  color: white;
  font-size: 1.6rem;
  font-weight: 400;
  padding-bottom: 2rem;
  text-shadow: 0.1rem 0.1rem 0.8rem black;
  animation-name: moveInRight;
  animation-duration: 1s;
  animation-timing-function: ease-out;
}

#header .fas {
  margin: 5% 0;
  font-size: 3rem;
}

#herder i:hover {
  cursor: pointer;
}

#header a .fas {
  color: white;
}

#header a .fas:hover {
  color: #ccc;
}

@keyframes moveInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  80% {
    transform: translateX(10px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes moveInRight {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  80% {
    transform: translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>